import { uniqBy } from "lodash-es";

import { EntityType, isDefined } from "@mapmycustomers/shared";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypeSupportingReports } from "@mapmycustomers/shared/types/entity";

import { listColumnsToExportColumnsMap } from "@app/util/fieldModel/ActivityFieldModel";

import getFieldModelByEntityType from "./getByEntityType";

const getColumnsVisibleByDefault = (entityType: EntityTypeSupportingReports) => {
  const fieldModel = getFieldModelByEntityType(entityType);

  let result = fieldModel.sortedFields.filter((field) =>
    field.hasFeature(FieldFeature.VISIBLE_BY_DEFAULT)
  );

  // TODO: think about supporting this on the FieldModel level
  if (entityType === EntityType.ACTIVITY) {
    result = uniqBy(
      result
        .flatMap((field) => {
          if (field.name in listColumnsToExportColumnsMap) {
            return listColumnsToExportColumnsMap[field.name].map((fieldName) =>
              fieldModel.getByName(fieldName)
            );
          } else {
            return field;
          }
        })
        .filter(isDefined),
      "name"
    );
  }

  return result;
};

export default getColumnsVisibleByDefault;
